export default __webpack_public_path__ + "static/media/gallery - story - three brothers (1)_02.317efef7.jpg";